<template>
  <div
    v-if="showRefusalIcon"
    class="eu-ml_1"
  >
    <emd-tippy
      v-if="showTippy"
      position="top"
      aria-expanded="true"
      type="html"
      data-testid="emd-tippy-dash-info-icon"
      :id="tooltipId"
      :data-template="tooltipId"
    >
      <em class="emd-text _color_success uil uil-info-circle" />
      <emd-tippy-template-HTML :id="tooltipId">
        <emd-text size="tiny">{{ $t('tooltip.title') }}:</emd-text>
        <emd-text
          v-for="item in tooltipItems"
          :key="item.name"
          size="tiny"
          data-testid="emd-text-dash-info-icon"
        >
          {{ $t(item.name) }}
          <b
            v-if="item.percentage"
            class="_type_bold"
          >
            - {{ item.percentage }}%</b
          >
          <br />
        </emd-text>
      </emd-tippy-template-HTML>
    </emd-tippy>
  </div>
</template>

<script>
import {
  EmdText,
  EmdTippy,
  EmdTippyTemplateHTML
} from 'emerald-vue/src/components'

export default {
  name: 'RefuseCodeTooltip',

  components: {
    EmdText,
    EmdTippy,
    EmdTippyTemplateHTML
  },

  props: {
    tooltipId: {
      type: String,
      default: 'refuseCode_info-tippy'
    },
    dataIcon: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        tooltip: []
      })
    }
  },

  computed: {
    tooltipItems () {
      return this.dataIcon?.tooltip
    },
    showRefusalIcon () {
      return this.dataIcon?.name.includes('tooltip')
    },
    showTippy () {
      return this.tooltipItems?.length > 0
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "tooltip": {
        "title": "Códigos de motivos de recusa"
      }
    },
    "en-US": {
      "tooltip": {
        "title": "Refusal reason codes"
      }
    }
  }
</i18n>
